//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/store/reducers/navbar.js
//
//  This file contains the 'navbar' reducer.
//

import { NAV_CKBOX_CH, NAV_TOPST_CH, NAV_BOTH_CH } from "../actionTypes";

const DEFAULT_STATE = {
  ckBox : "map",  // Initial state of the ["Map"]["Full"]["Compact"] part of the Navbar, 'map', 'full', 'compact'
  topSt : "page", // Initial state of the Navbar "city", "page", "login" (must set to page)
  sCat  : "grill" // Initial state of the search Category: "grill", "bars", "rests", "music"
};

//
//  Note: In Redux, all reducers get called regardless of the action,
//  so inside each one you have to return the original 'state' if the
//  action is not applicable.
//
export default ( state = DEFAULT_STATE, action ) => {

  switch( action.type ) {

  case NAV_CKBOX_CH:  {
    console.log( "Navbar Reducer Action = " + action.type + ", ckBox = " + action.ckBox );
    return { ...state, ckBox : action.ckBox, topSt : "page" }; }

  case NAV_TOPST_CH:   {
    console.log( "Navbar Reducer Action = " + action.type + ", topSt = " + action.topSt );
    return { ...state, topSt : action.topSt }; }

  case NAV_BOTH_CH:   {
    console.log( "Navbar Reducer Action = " + action.type + ", topSt = " + action.topSt + ", sCat = " + action.sCat );
    return { ...state, topSt : action.topSt, sCat : action.sCat }; }

  default:  return state;
  }
};




// WEBPACK FOOTER //
// ./src/store/reducers/navbar.js